import SelectField from "./SelectField";
import inputStyle from "./InputStyles.module.css";
import styles from "./Webhook.module.css";
import { useContext } from "react";
import { FormContext } from "./FormField";

function Request() {
  const { fields, setValue } = useContext(FormContext);
  return (
    <div className={styles.card}>
      <SelectField
        name="method"
        label={<h2>Método de solicitud</h2>}
        inputClassName={inputStyle.input}
        labelClassName={inputStyle.label}
        initialValue={fields.method}
        onChange={(e) => setValue({ method: e.target.value })}
        options={[
          {
            label: "POST",
            value: "POST",
          },
          {
            label: "GET",
            value: "GET",
          },
          { label: "PUT", value: "PUT" },
          { label: "DELETE", value: "DELETE" },
        ]}
      />
    </div>
  );
}

export default Request;
